// src/exercise/utils/weatherCanvas.js

/**
 * Creates a canvas with weather information rendered
 * @param {Object} weatherData - { location, temperature, condition }
 * @returns {HTMLCanvasElement}
 */
export function createWeatherCanvas(weatherData) {
  const canvas = document.createElement('canvas');
  canvas.width = 1024;  // Power of 2 for GPU efficiency
  canvas.height = 1024;
  
  const ctx = canvas.getContext('2d');
  
  // Background - dark gradient
  const gradient = ctx.createLinearGradient(0, 0, 0, 1024);
  gradient.addColorStop(0, '#64b2d1ff');
  gradient.addColorStop(1, '#21305cff');
  ctx.fillStyle = gradient;
  ctx.fillRect(0, 0, 1024, 1024);
  
  // Location (top)
  ctx.fillStyle = '#ffffff';
  ctx.font = 'bold 80px Arial, sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(weatherData.location.toUpperCase(), 512, 300);
  
  // Temperature (center, large)
  ctx.font = 'bold 200px Arial, sans-serif';
  ctx.fillText(`${weatherData.temperature}°C`, 512, 512);
  
  // Condition (bottom)
  ctx.font = '60px Arial, sans-serif';
  ctx.fillStyle = '#aaaaaa';
  ctx.fillText(weatherData.condition.toUpperCase(), 512, 700);
  
  return canvas;
}

/**
 * Updates existing canvas with new weather data
 * @param {HTMLCanvasElement} canvas 
 * @param {Object} weatherData 
 */
export function updateWeatherCanvas(canvas, weatherData) {
  const ctx = canvas.getContext('2d');
  
  // Clear and redraw
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  
  // (Same drawing logic as createWeatherCanvas)
  const gradient = ctx.createLinearGradient(0, 0, 0, 1024);
  gradient.addColorStop(0, '#64b2d1ff');
  gradient.addColorStop(1, '#21305cff');
  ctx.fillStyle = gradient;
  ctx.fillRect(0, 0, 1024, 1024);
  
  ctx.fillStyle = '#ffffff';
  ctx.font = 'bold 80px Arial, sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(weatherData.location.toUpperCase(), 512, 300);
  
  ctx.font = 'bold 200px Arial, sans-serif';
  ctx.fillText(`${weatherData.temperature}°C`, 512, 512);
  
  ctx.font = '60px Arial, sans-serif';
  ctx.fillStyle = '#aaaaaa';
  ctx.fillText(weatherData.condition.toUpperCase(), 512, 700);
}
